import IdNameAndNumber from "../../../types/report/IdNameAndNumber";
import NumberType from "../../../types/report/NumberType";

const getHightestNumberInCollection = (collection: NumberType[]) => {
    let maxNumber = Number.MIN_VALUE;

    collection.forEach((item) => {
        maxNumber = Math.max(item.number, maxNumber);
    });
    return maxNumber;
}

const getLowestNumberInCollection = (collection: NumberType[]) => {

    let minNumber = Number.MAX_VALUE;

    collection.forEach((item) => {
        minNumber = Math.min(item.number, minNumber);
    });
    return minNumber;
}

export { getHightestNumberInCollection, getLowestNumberInCollection };
